/* eslint-disable linebreak-style */
import { getCurrentLocale } from '../i18n';

const getStringValue = (candidate)=>{
  if (typeof candidate !== 'string') {
    return '';
  }
  return candidate.trim();
};

const normalizeKey = (value)=>{
  return String(value || '')
    .toLowerCase()
    .replace(/[^a-z]/g, '');
};

const getFirstNonEmptyValue = (source, keys = [])=>{
  if (!source || typeof source !== 'object') {
    return '';
  }
  for (const key of keys) {
    const value = getStringValue(source[key]);
    if (value) {
      return value;
    }
  }
  return '';
};

const getFirstNonEmptyValueByNormalizedKeys = (source, normalizedKeys = [])=>{
  if (!source || typeof source !== 'object') {
    return '';
  }
  const normalizedMap = {};
  Object.keys(source).forEach(key=>{
    normalizedMap[normalizeKey(key)] = source[key];
  });
  for (const normalizedKey of normalizedKeys) {
    const value = getStringValue(normalizedMap[normalizedKey]);
    if (value) {
      return value;
    }
  }
  return '';
};

const getLocaleSuffix = (locale)=>{
  if (locale === 'en') {
    return 'En';
  }
  if (locale === 'bg') {
    return 'Bg';
  }
  return '';
};

const getLocalizedKeys = (baseField, locale)=>{
  const suffix = getLocaleSuffix(locale);
  const suffixLower = suffix.toLowerCase();
  const suffixUpper = suffix.toUpperCase();
  if (!suffix) {
    return [];
  }
  if (baseField === 'denumire') {
    return [
      `denumire${suffix}`
    ];
  }
  if (baseField === 'atentionare') {
    return [
      `atentionare${suffix}`,
    ];
  }
};

const getLocalizedNormalizedKeys = (baseField, locale)=>{
  const suffix = getLocaleSuffix(locale);
  if (!suffix) {
    return [];
  }
  const suffixLower = suffix.toLowerCase();
  if (baseField === 'denumire') {
    return [
      `denumire${suffixLower}`,
    ].map(normalizeKey);
  }
  if (baseField === 'atentionare') {
    return [
      `atentionare${suffixLower}`,
    ].map(normalizeKey);
  }
  return [];
};

const getBaseKeys = (baseField)=>{
  if (baseField === 'denumire') {
    return ['denumire', 'Denumire'];
  }
  if (baseField === 'atentionare') {
    return ['atentionare', 'Atentionare'];
  }
  return [baseField];
};

export const getLookupLocalizedField = (entry, baseField, locale = getCurrentLocale())=>{
  const localizedValue = getFirstNonEmptyValue(entry, getLocalizedKeys(baseField, locale));
  if (localizedValue) {
    return localizedValue;
  }
  const localizedValueFromNormalizedKeys = getFirstNonEmptyValueByNormalizedKeys(
    entry,
    getLocalizedNormalizedKeys(baseField, locale)
  );
  if (localizedValueFromNormalizedKeys) {
    return localizedValueFromNormalizedKeys;
  }
  return getFirstNonEmptyValue(entry, getBaseKeys(baseField));
};

export const getLookupLabel = (entry, locale = getCurrentLocale())=>{
  return getLookupLocalizedField(entry, 'denumire', locale);
};

export const getLookupWarning = (entry, locale = getCurrentLocale())=>{
  return getLookupLocalizedField(entry, 'atentionare', locale);
};

const fieldNameVariants = (baseField, suffix)=>{
  const root = String(baseField || '');
  const roots = [
    root,
    root.charAt(0).toUpperCase() + root.slice(1),
    root.charAt(0).toLowerCase() + root.slice(1)
  ];
  const names = [];
  roots.forEach(name=>{
    if (!suffix) {
      names.push(name);
      return;
    }
    names.push(`${name}${suffix}`, `${name}${suffix.toLowerCase()}`, `${name}${suffix.toUpperCase()}`);
  });
  return names;
};

export const getLocalizedText = (entry, baseField, locale = getCurrentLocale())=>{
  const suffix = getLocaleSuffix(locale);
  if (suffix) {
    const localizedValue = getFirstNonEmptyValue(entry, fieldNameVariants(baseField, suffix));
    if (localizedValue) {
      return localizedValue;
    }
  }
  return getFirstNonEmptyValue(entry, fieldNameVariants(baseField, ''));
};
